import axios, { AxiosResponse } from "axios";
import { S10CouponsToMyChargeHistoryPartial, S10CouponsToMyChargePartial, S10CouponsTypesResponse, S10CouponsVacationRangeRequest, S10CouponsVacationRangeResponse, S10EmployeesCouponsRequest, S10SendRequestCouponResponsibles, S10UpdateCoupon, SetAproveCouponCloudData } from "../interfaces/s10Employees.interface";
import { store } from "../store";
import { CompanyEmployees } from "../interfaces/auth.interface";
import { COUPONS_TO_MY_CHARGE_HISTORY_ONE, COUPONS_TO_MY_CHARGE_HISTORY_TWO } from "../constants/signalRequestConsts";
import { CouponsToMyChargeRequestId } from "../store/slices/userRequests";
import { setupInterceptors } from "../utils/requests";



const s10DocumentsApi = axios.create({
    baseURL: process.env.REACT_APP_DOCUMENTS_S10_API,
	headers: {
		moduleId: process.env.REACT_APP_MODULE_ID,
	}
})

const s10CollaboratorsApi = axios.create({
    baseURL: process.env.REACT_APP_COLLABORATORS_S10_API,
	headers: {
		moduleId: process.env.REACT_APP_MODULE_ID,
	}
})


// const s10Api = axios.create({
//     baseURL: process.env.REACT_APP_MODULES_S10_API,
// 	headers: {
// 		moduleId: process.env.REACT_APP_MODULE_ID,
// 	}
// })

// export const getPresignedUrlRequest = async (token: string, numberFS: string) => {
// 	const headers = {
// 		token,
// 		AccessType: 1,
// 	};
	
// 	const result = await s10Api.get( 
// 		`/FileStorage/api/FileStorageApi/DownloadSignedById?id=${numberFS}`,
// 		{headers}
// 	)
// 		.then(r => r)
// 		.catch(e => e);
// 	return result
// }


s10DocumentsApi.interceptors.response.use((config) => config, setupInterceptors);
s10CollaboratorsApi.interceptors.response.use((config) => config, setupInterceptors);




export const getsignedDocumentRequest = async (token: string, numberFS: string, firmaTop: string, userFullName: string) => {
	const headers = {
		token,
	};
	const data = {
		id: numberFS,
		signTopPosicion: firmaTop,
		employeeName: userFullName,
	}
	const result = await s10DocumentsApi.post( 
		`/DocumentApi/SignFileStorage64`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getsignedDocumentContractRequest = async (
	token: string,
	numberFS: string,
	firmaTop: string,
	firmaLeft: string,
	FirmaPagePosition: string,
	userFullName: string,
	isContract?: boolean,
) => {
	const headers = {
		token,
	};
	const data = {
		id: numberFS,
		signTopPosicion: firmaTop,
		signLeftPosicion: firmaLeft,
		signPagePosicion: FirmaPagePosition,
		employeeName: userFullName,
		isContract,
	}
	const result = await s10DocumentsApi.post( 
		`/DocumentApi/SignFileStorage64`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}


export const getEmployeeCoupons = async ({
	page, 
	quantity,
	status,
	startDate,
	endDate,
	couponId
}: S10EmployeesCouponsRequest) => {
	const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
		AccessType: 1,
	};
	const params = {
		employeeCode: companyselected?.Code,
		quantity,
		page,
		status,
		startDate,
		endDate,
		couponId,
	} as any;
	const urlParams = new URLSearchParams(params);
	const result = await s10CollaboratorsApi.get( 
		`/api/UseEmployeeCouponApi/CouponByEmployee?${urlParams.toString()}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}


export const getCouponsTypesRequest = async (processType: 1 | 0 | -1, isActive: 1 | 0 | -1): Promise<S10CouponsTypesResponse[]> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const url = `/api/UseEmployeeCouponApi/AvailableCouponsTypeByEmployee?processType=${processType}&isActive=${isActive}`;
	console.log(url)
	const result = await s10CollaboratorsApi.get(url, {headers})
		.then((r: AxiosResponse<any>) => r.data as S10CouponsTypesResponse[])
		.catch(e => {
			console.log(e);
			return []
		});
		console.log(result)
	return result
}

export const updateCouponTypeRequest = async (data: S10UpdateCoupon): Promise<any> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const result = await s10CollaboratorsApi.post( 
		`/api/CouponApi/UpdateCouponInformation`, data,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data as any[])
		.catch(e => {
			console.log(e);
			return null
		});
	return result
}

export const updateCouponTypeImageRequest = async (couponId: number, fileStorageId: string): Promise<any> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const data = {
		CouponId: couponId,
    	FileStorageId: fileStorageId,
	}
	const result = await s10CollaboratorsApi.post( 
		`/api/CouponApi/UpdateCouponFileStorageInformation`, data,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data as any[])
		.catch(e => {
			console.log(e);
			return null
		});
	return result
}
// [dbo].[S10_15_BoletaNomina_PorSocioNegocioPaginado] 
// 	@CodIdentificador	Varchar(8),
// 	@Descripcion		VARCHAR(120),
// 	@NumeroPagina		INTEGER = 1,
// 	@TamanoPagina		INTEGER = 30,
// 	@EtiquetaPagina		VARCHAR(20)  = Null OUTPUT
// Para el ultimo parametro que es OUTPUT , no recuerdo si en tablero lo manejamos , pero no debes especificarlo en tu llamada
// Al momento de ejecutar el POST del signal debes poner "HasOutputParam": true, y en la respuesta te vendrá un Output: "XX"
// En este caso como es una paginación con el X/X de la pagina en la que vas


export const setCouponsTypesRequest = async (requestData: S10CouponsVacationRangeRequest): Promise<S10CouponsVacationRangeResponse | null> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const data = requestData
	const result = await s10CollaboratorsApi.post( 
		`/api/UseEmployeeCouponApi/AddCouponRequested`,
		data,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data as S10CouponsVacationRangeResponse)
		.catch(e => {
			console.log(e);
			return null
		});
	return result
}

export const setCouponsHasAttachmentFlag = async (useEmployeeCouponId: number, hasAttachment: boolean): Promise<S10CouponsVacationRangeResponse | null> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const data = {
		UseEmployeeCouponId: useEmployeeCouponId,
		HasAttachment: hasAttachment,
	}
	const result = await s10CollaboratorsApi.post( 
		`/api/UseEmployeeCouponApi/UpdateHasAttachmentCoupon`,
		data,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data as S10CouponsVacationRangeResponse)
		.catch(e => {
			console.log(e);
			return null
		});
	console.log(result)
	return result
}

export const sendEmailRequestCouponResponsibles = async (requestData: S10SendRequestCouponResponsibles): Promise<any | null> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const data = {
		...requestData,
		FromNewPortal: 1,
	}
	const result = await s10CollaboratorsApi.post( 
		`/api/UseEmployeeCouponApi/SendMailCouponRequested`,
		data,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data )
		.catch(e => {
			console.log(e);
			return null
		});
	return result
}

export const setCancelCouponrequest = async (useEmployeeCouponId: number): Promise<any | null> => {
	const {auth} = store.getState();
	const headers = {
		token: auth.companyselected?.Token,
		AccessType: 1,
	};
	const data = {
		FromNewPortal: 1,
		UseEmployeeCouponId: useEmployeeCouponId,
		EmployeeInfo: {
			Corporation: auth.companyselected?.Name,
			CompanyName: "-",
			FullName: auth.sessionData?.FullName,
			Email: auth.sessionData?.UserName,
		}
	}
	const result = await s10CollaboratorsApi.post( 
		`/api/UseEmployeeCouponApi/CancelCouponRequested`,
		data,
		{headers}
	)
		.then((r: AxiosResponse<any>) => {
			console.log(r.data)
			return r.data })
		.catch(e => {
			console.log(e);
			return null
		});
	return result
}

export const getCouponsTypesUsedByEmployeeRequest = async (): Promise<S10CouponsTypesResponse[]> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const result = await s10CollaboratorsApi.get( 
		`/api/UseEmployeeCouponApi/CouponUsageByEmployee?employeeCode=${authCompanySelectedState?.Code}`,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data as S10CouponsTypesResponse[])
		.catch(e => {
			console.log(e);
			return []
		});
	return result
}

export const getToMyChargePenddingCoupons = async (): Promise<S10CouponsToMyChargePartial[]> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const result = await s10CollaboratorsApi.get( 
		`/api/UseEmployeeCouponApi/GetForApprovalCoupons?employeeCode=${authCompanySelectedState?.Code}`,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data as S10CouponsToMyChargePartial[])
		.catch(e => {
			console.log(e);
			return []
		});
	return result
}

export const getToMyChargeCouponsHistory = async (
	status: string, 
	couponType: string, 
	requestId: CouponsToMyChargeRequestId, 
	quantityPerPage: number, 
	page: number
): Promise<{totalCount: number, items: S10CouponsToMyChargeHistoryPartial[]}> => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const url = requestId === COUPONS_TO_MY_CHARGE_HISTORY_ONE
					? "/api/UseEmployeeCouponApi/GetForApprovalCoupons?"
					: requestId === COUPONS_TO_MY_CHARGE_HISTORY_TWO
						? `/api/UseEmployeeCouponApi/GetApprovedRejectedCoupons?`
						: "/api/UseEmployeeCouponApi/ApprovalCouponHistory?"
	
	const fullUrl = `${url}quantity=${quantityPerPage || 25}&page=${page || 1}&employeeCode=${authCompanySelectedState?.Code}&status=${status}&couponId=${couponType}`;
	const result = await s10CollaboratorsApi.get( 
		fullUrl,
		{headers}
	)
		.then(({data}: any) => ({
			totalCount: data.ItemsCount, 
			items: data.Items as S10CouponsToMyChargeHistoryPartial[]
		}))
		.catch(e => {
			console.log(e);
			return {totalCount: 0, items: []}
		});
	// console.log(fullUrl, result)
	return result
}

export const setAproveCouponCloud = async (): Promise<any> => {
	const {companyselected, sessionData} = store.getState().auth;
	const {couponToApprove, couponToApproveERPResponse} = store.getState().userRequests[COUPONS_TO_MY_CHARGE_HISTORY_ONE];
	console.log(couponToApproveERPResponse)
	// const couponToApproveERPResponse = {Success: 1, Response: 'Papeleta N° 00003685 se ha creado satisfactoriamente.', Code: 'F97A6A3B-3B34-4D6E-BFE8-9C37572CAE9F;00003685'}
	const headers = {
		token: companyselected?.Token,
		AccessType: 1,
	};
	if (!couponToApprove) {
		console.log("couponToApprove is null, it was't posible to send cloud notification")
		return false;
	}
	if (!companyselected || !sessionData) {
		console.log("companyselected or sessionData are null, it was't posible to send cloud notification")
		return false;
	}
	if (!couponToApproveERPResponse?.Code) {
		console.log("couponToApproveERPResponse is null, it was't posible to send cloud notification")
		return false;
	}
	const data: SetAproveCouponCloudData = {
		FromNewPortal: 1,
		UseEmployeeCouponId: couponToApprove.Id,
		Approver: {
			Code: companyselected.Code,
			FullName: companyselected.Name,
		},
		Employee: {
			Corporation: sessionData.FullName,
			CompanyName: couponToApprove.DescripcionEmpresa,
			FullName: couponToApprove.Descripcion,
			Email: couponToApprove.EMail,
		},
		Code: couponToApproveERPResponse.Code,
	}
	console.log(data)
	const result = await s10CollaboratorsApi.post( 
		`/api/UseEmployeeCouponApi/ApproveCoupon`,
		data,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data as any)
		.catch(e => {
			console.log(e);
			return false
		});
	return result
}

export const setRejectCouponCloud = async (couponRequestData: S10CouponsToMyChargePartial & CompanyEmployees): Promise<any> => {
	const {companyselected} = store.getState().auth;
	const headers = {
		token: companyselected?.Token,
		AccessType: 1,
	};
	if (!companyselected) {
		console.log("companyselected is null, it was't posible to send cloud notification")
		return;
	}
	const data = {
		UseEmployeeCouponId: couponRequestData.Id,
		RejectingEmployeeCode: companyselected.Code,
	
	}
	const result = await s10CollaboratorsApi.post( 
		`/api/UseEmployeeCouponApi/RejectCoupon`,
		data,
		{headers}
	)
		.then((r: AxiosResponse<any>) => r.data as any)
		.catch(e => {
			console.log(e);
			return {}
		});
	return result
}



export const getCalendarMonthEvents = async (
	year: number, 
	month: number,
	isPrincipal: boolean,
): Promise<any> => {
	const {companyselected} = store.getState().auth;
	const headers = {
		token: companyselected?.Token,
		AccessType: 1,
	};
	if (!companyselected) {
		console.log("companyselected is null, it was't posible to get cloud data")
		return;
	}
	const result = await s10CollaboratorsApi.get( 
		`/api/UseEmployeeCouponApi/GetCalendarMonthlyCoupon?employeeCode=${companyselected.Code}&year=${year}&month=${month}&principalCode=${isPrincipal ? companyselected.Code : ''}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}


export const setRevertCouponAppovation = async (UseEmployeeCouponId: number): Promise<any> => {
	const {companyselected, sessionData} = store.getState().auth;
	const headers = {
		token: companyselected?.Token,
		AccessType: 1,
	};
	if (!companyselected) {
		console.log("companyselected is null, it was't posible to get cloud data")
		return;
	}

	const data = {
		FromNewPortal: 1,
		UseEmployeeCouponId: UseEmployeeCouponId, //ID de la solicitud
		EmployeeInfo: {
			Corporation: companyselected?.Name,
			CompanyName: "-",
			FullName: sessionData?.FullName,
			Email: sessionData?.UserName,
		}
	}


	const result = await s10CollaboratorsApi.post( 
		`/api/UseEmployeeCouponApi/RevertCouponProcessed`,
		data,
		{headers}
	)
		.then(r => r.data)
		.catch(e => e);
	return result
}

export const getEmployeePrincipalsCodes = async (): Promise<any> => {
	const {companyselected} = store.getState().auth;
	const headers = {
		token: companyselected?.Token,
		AccessType: 1,
	};
	const result = await s10CollaboratorsApi.get( 
		`/api/UseEmployeeCouponApi/GetOfficePrincipalsByEmployeeCode?employeeCode=${companyselected?.Code}`,
		{headers}
	)
		.then(r => r.data)
		.catch(e => e);
	return result
}